import { FC } from "react";
import { AnyTask, Market, SortOrder } from "tm-shared/types";

import { ItemListView } from "@/components/ItemListView";
import { MarketHeaderView } from "@/components/ItemListView/MarketHeaderView";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import {
    patchProductsSelectedFilters,
    setProductsSortOrder,
    setProductsSortTag,
    setWorkPlanActiveCollapse,
} from "@/store/slices/ui";

import { MarketBody } from "../MarketBody";

interface MarketListProps {
    markets: Market[];
    onOpenTasksInfoModal: (params: { task: AnyTask; market: Market }) => void;
}

export const MarketList: FC<MarketListProps> = ({
    markets,
    onOpenTasksInfoModal,
}) => {
    const dispatch = useAppDispatch();

    const { activeCollapse } = useAppSelector((s) => s.ui.workPlan);

    const onChangeCollapse = (newActiveKey: string) => {
        dispatch(setWorkPlanActiveCollapse(newActiveKey));
        dispatch(patchProductsSelectedFilters({}));
        dispatch(setProductsSortOrder(SortOrder.Asc));
        dispatch(setProductsSortTag(null));
    };

    return (
        <ItemListView
            items={markets}
            activeCollapse={activeCollapse}
            onChangeCollapse={onChangeCollapse}
            HeaderComponent={MarketHeaderView}
            BodyComponent={MarketBody}
            bodyProps={{ onOpenTasksInfoModal }}
        />
    );
};
